let xmlRequest = `
<?xml version="1.0" encoding="utf-8"?>
<request>
    <warehouseCode>仓库编码, string (50), 必填</warehouseCode>
    <ownerCode>货主编码 string (50), 必填</ownerCode>
    <itemCode>父件商品编码, string (50), 必填</itemCode >
    <items>
        <item>
            <itemCode>子件商品编码, string (50),必填</itemCode>
            <itemId>仓储系统商品编码, string (50)</itemId>
            <quantity>子件数量, int, 必填</quantity>
        </item>
    </items>
</request>
`

let xmlResponse = `
<?xml version="1.0" encoding="utf-8"?>
<response>
    <flag>success|failure</flag>
    <code>响应码</code>
    <message>响应信息</message>
</response>
`

export default {xmlRequest, xmlResponse}



// WEBPACK FOOTER //
// ./src/data/openapi/openapi.combineitem.synchronize.js